import React from 'react';
import { UserActivityDetailSkeleton } from '@components/Feed/User/Skeleton';
import { PurchaseCardSkeleton } from '@components/SongCards/PurchaseCard/PurchaseCardSkeleton';
import {
  GridCarousel,
  SSR_SLIDE_WIDTH_DEFAULT,
} from '@components/main-components/carousel/GridCarousel';
import { MediaQuery } from '@context/mediaQuery';
import { ComponentContainer } from '../shared';
import { ComponentWrapper, Mask } from '.';

export const UserCollectedManySkeleton = () => {
  const { tablet } = MediaQuery.useContainer();

  const slides = Array.from({ length: 3 }).map((_, i) => ({
    id: i.toString(),
    slide: <PurchaseCardSkeleton key={i} />,
  }));

  return (
    <ComponentContainer noPadding>
      <UserActivityDetailSkeleton />
      <ComponentWrapper css={{ marginBottom: 'unset' }}>
        {!tablet && <Mask />}
        <GridCarousel
          slides={slides}
          onEndReached={null}
          onInternalActiveIndexChange={null}
          columnAmount={null}
          hideArrows={false}
          externalActiveIndex={null}
          spacing={null}
          alignSlidesLeft={false}
          ssrSlideWidth={SSR_SLIDE_WIDTH_DEFAULT}
          columnType="large"
        />
      </ComponentWrapper>
    </ComponentContainer>
  );
};
